import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

import {Swiper, SwiperSlide } from "swiper/react"
import {Autoplay} from "swiper"
import "swiper/css/bundle"

import { castBody, h2Linked, h2Unlinked, nl2br, diaryArticle } from "./core/core"

import SideNav from "./components/sideNav"
import { hvnUriRoot, apiRoot, rootUri } from "./core/defines"
import { useCastData } from "./service/castData"
import useCastEffect from "./service/useCastData"


function rebuildDate(m,d){
    const now = new Date().getFullYear()

    return `${now}-${m}-${d}`

}

function castSchedule(d){

    const [month,date]=d.date.split("/")

    const days=["日", "月","火","水","木","金", "土",]
    const wd= new Date(rebuildDate(month, date)).getDay()
    console.log(wd)

    return(
        <li className="day">
            <time>{d.date} {`(${days[wd]})`}</time>
            {d.is_work_day
                    ? `${d.start}~${d.end}`
                    : "-"}
        </li>
    )
}

function profContents(profiles){
    const resMaker = (key) => {
        return (<div className="block">
                    <h3>{ profiles[key].title }</h3>
                    <p>{ nl2br(profiles[key].body) }</p>
                </div>)
    }

    if(profiles != undefined){
        return Object.keys(profiles).map((k)=>resMaker(k))
    }

}


function reserveBtn(hvnId){

    let id =""
    let linkTxt= "キャストを予約する"
    if(hvnId){
        id= `?girl_id=${hvnId}`
    }

    return(
        <nav className="wrapper-link">
            <a className="btn-link reserve"
                href={`${hvnUriRoot}/A6ShopReservation/${id}`} id="book_5" target="_blank" rel="noreferrer noopener">{linkTxt}</a>
        </nav>
    )
}


function linkBtn($url, $txt){
    if($url){
        return(
            <div className="wrapper-link">
                <a className="btn-link link-mov" target="_blank" rel="noreferrer noopener"
                    href={$url}>{$txt}</a>
            </div>
        )
    }
}

function diaryBlock(diaryData){

    const  diaryArticle = (json)=>{

            // let imgPath = "/img/nophoto-diary.jpg"
            // if(json.url_img != "null"){ imgPath = json.url_img}

            return (
                <li key={json.url_img} className="content">
                    <a href={json.url_link} target="_blank" rel="noreferrer noopener">
                        <div className="wrappar-img">
                            {json.media_type == "video" && <video src={json.content_url}></video>}
                            {json.media_type == "img" && <img src={json.content_url} />}
                        </div>
                        <h3>{json.title}</h3>
                    </a>
                </li>)}

    if (Array.isArray(diaryData)) {
        return (
            <section className="block-diary">
                {h2Unlinked("写メ日記")}
                <ul className="diary-wrappar">
                    {diaryData.map((d) => diaryArticle(d))}
                </ul>
            </section>
        );
    } else {
        console.warn("diaryData is not an array:", diaryData);
        return null; // またはエラーメッセージ表示
    }
}

function Profile(){
    const {castId} = useParams();
    const [castData, setCData]    = useState([]);
    const [schedule, setSchedule] = useState([]);
    const [slideArr, setSlideArr] = useState([]);
    const [diary, setDiary] = useState([]);

    const {fetchProfile, fetchCastDiary}=useCastEffect()
    const {hvnId, updateHvnId, resetHvnId} = useCastData()

    const slideKeys = [0,1,2,3,4,5,6,7,8,9];



    useEffect(()=>{

        console.log("effect triggered.")


        const init = async(id)=>{

            const res= await fetchProfile({castID: id})

            if(res.result){
                console.log(res.data)

                setCData(res.data);
                setSchedule(res.data.schedule);
                setSlideArr(res.data.photos);

                if(res.data.c_id_hvn){
                    updateHvnId(res.data.c_id_hvn)
                    setDiary(await fetchCastDiary(res.data.c_id_hvn))
                }
            }
        }

        init(castId);

        return()=>{
            resetHvnId()
        }
    },[castId]);


    return(
        <>
        <div className="container bg-w-alpha">
            <article id="profile" className="main-colmn">
                <section>
                    {h2Linked(castData.c_name, "一覧", "/allcasts")}
                    <div className="txt-center">
                        <Swiper
                            modules={[Autoplay]}
                            loop={true}
                            slidesPerView={1.2}
                            autoplay={true}
                            centeredSlides={true}
                            breakpoints={{ 768:{slidesPerView:3},}}
                        >

                            {slideArr.length>0 &&
                                slideKeys.map((val) => {
                                    if(slideArr[val] == 1){
                                        return <SwiperSlide key={val}><img src={ `${rootUri}/d/p${castData.id}_${1+val}.jpg`} /></SwiperSlide>
                                    }
                            })}
                        </Swiper>
                        <h3>{castData.cast_name} {Number(castData.age)>0 && `(${castData.age})`}</h3>
                        {castBody(castData.body)}
                        <div className="btn-wrap">
                            {castData.is_vip               && <span class="btn vip">VIP</span>}
                            {castData.is_newface           && <span class="btn new">新人</span>}
                            {castData.is_recommend         && <span class="btn reco">イチ推し</span>}
                            {Boolean(castData.has_diary)   && <span class="btn diy">写メ日記</span>}
                            {Boolean(castData.url_mov)     && <span class="btn mov">動画</span>}
                            {Boolean(castData.has_gravures)  && <span class="btn gravures">グラビア</span>}
                        </div>
                    </div>
                </section>
                <section>
                    {h2Unlinked("プロフィール")}
                    <div className="layout-box">
                        { profContents(castData.profiles) }
                    </div>
                    {h2Unlinked("スケジュール")}
                    <div className="layout-box">
                        <ul className="prof-schedule">
                            {schedule.map((sc)=> castSchedule(sc))}
                        </ul>
                    </div>
                    {castData && reserveBtn(hvnId)}
                </section>
                {diary.length
                    ? diaryBlock(diary)
                    : null}
                {castData && linkBtn(castData.url_diary, "写メ日記をみる")}
                {castData && linkBtn(castData.url_mov, "動画をみる")}
                {castData.url_gravures && castData.url_gravures.map(url=>linkBtn(url, "グラビアをみる")) }

            </article>
            <SideNav />
        </div>
        </>
    )
}
export default Profile;